import axios from "axios";
import _ from "lodash";
import constants from "@/config/constants";

function initialState() {
    return {
        item: {
                  
        },       
        is_new: false,
        is_editing: false,
        loading: false,
    }
}

const getters = {
    item: state => state.item,
    loading: state => state.loading,
    is_new: state => state.is_new,
    is_editing: state => state.is_editing,
  
}

const actions = {

    setItem({ commit }, value) {
        commit('setItem', value);
    },

    async storeData({ commit, state }, event_id) {
        commit('setLoading', true)

        const params = _.cloneDeep(state.item);

       
        delete params.image;
      
       
        params.event_id = event_id;

       
        console.log("params after",params);
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };

       
        return axios.post(constants.API_URL + '/api/landing-page/faq', params, {headers: headers})
            .then(response => {
                commit('resetState')
                return response;
               
            }).finally(() => {
                commit('setLoading', false)
            })
    },
    async updateData({ commit, state }) {
        commit('setLoading', true);
      
        const params = _.cloneDeep(state.item);
      
        // Clean up the object before sending
        delete params._id;
        delete params.__v;
        delete params.createdAt;
        delete params.updatedAt;
        delete params.is_open_new_window;
      
        const headers = {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
        };
      
        try {
          const response = await axios.patch(
            `${constants.API_URL}/api/landing-page/faq/${state.item._id}`,
            params,
            { headers }
          );
          console.log("responseresponse",response,response.data);
          commit('setItem', response.data);
          return response;
        } finally {
          commit('setLoading', false);
        }
    },
    destroyData({ commit, state }, id) {
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };

       
        return axios.delete(constants.API_URL + '/api/landing-page/faq/' + id, {headers: headers})
            .then(response => {
                commit('resetState');
                commit('setItem', state.item.filter((item) => {
                    return item.id != id
                }))



                return response;
            })
            .catch(error => {
                console.error(error)
                return error;
            })
    },
    fetchData({ commit, dispatch }, {id}) {
        console.log("Working hit");
       
        const headers = {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        };
       
        return axios.get(constants.API_URL + '/api/event-cms/tag/' + id, {headers: headers})
        //return axios.get(constants.API_URL + '/api/events/' + event_id + '/sponsors/' + id, {headers: headers})
            .then(response => {
                commit('setItem', _.get(response, 'data.data', {}));
                return response;
            })
    },
    setEvent({ commit }, value) {
        commit('setEvent', value)
    },
    setQuestion({ commit }, value) {
        commit('setQuestion', value)
    },
    setAnswer({ commit }, value) {
        commit('setAnswer', value)
    },
    resetState({ commit }) {
        commit('resetState')
    },
    setIsNew({ commit }, value) {
        commit('setIsNew', value);
    },
    setIsEditing({ commit }, value) {
        commit('setIsEditing', value);
    }
}

const mutations = {
    setItem(state, item) {
        state.item = item
    },
    setEvent(state, value) {
        state.item.event_id = value
    },
    setQuestion(state, value) {
        state.item.question = value
    },
    setAnswer(state, value) {
        state.item.answer = value
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setIsNew(state, value) {
        state.is_new = value;
    },
    setIsEditing(state, value) {
        state.is_editing = value;
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
